import Head from 'next/head';
import ProgramHero from '../src/components/mentorship/Hero';
import mentorshipPrograms from '../src/data/mentorship-programs.json';
import StatsCardsWrapper from '../src/components/mentorship/Stats';
import ProgramOutcomesSection from '../src/components/mentorship/ProgramOutcomesSection';
import SuccessStories from '../src/components/home/SuccessStories';
import CompaniesSection from '../src/components/home/CompaniesSection';
import TestimonialsSection from '../src/components/home/TestimonialsSection';
import Business from '../src/components/home/Business';
import StickyBanner from '../src/components/mentorship/Sticky';

export async function getStaticPaths() {
  // Generate paths for all slugs in mentorshipPrograms
  const paths = mentorshipPrograms.map((program) => ({
    params: { slug: program.slug },
  }));

  return {
    paths,
    fallback: false, // Show 404 for unknown slugs
  };
}

export async function getStaticProps({ params }) {
  const program = mentorshipPrograms.find((p) => p.slug === params.slug);

  if (!program) {
    return {
      notFound: true,
    };
  }

  return {
    props: {
      program,
      mentorshipPrograms, // pass if needed in StickyBanner
    },
  };
}

export default function ProgramDetailPage({ program, mentorshipPrograms }) {
  return (
    <>
      <Head>
        <title>{program.heading} | GrowthSchool</title>
        <meta name="description" content={program.subheading} />
      </Head>

      <div>
        <ProgramHero program={program} />
        <StatsCardsWrapper />
        <ProgramOutcomesSection />

        <SuccessStories />
        <CompaniesSection />
        <TestimonialsSection />
        <Business />
        <StickyBanner programs={mentorshipPrograms} />
      </div>
    </>
  );
}
